export default function filterMaxCharacterCount(str: any, max: any) {
  const characterCountCheck = str
    .split(' ')
    .filter((word: any) => word.length >= max)
  return !!characterCountCheck.length
}
